// extracted by mini-css-extract-plugin
module.exports = {"statuses":"style_statuses__3hELo"};